/* ─── FastSell Premium Design Tokens ─── */

export const SF = {
  colors: {
    primary:      "#2563EB",
    primaryHover: "#1D4ED8",
    primaryLight: "#DBEAFE",

    neutral0:   "#FFFFFF",
    neutral50:  "#F8FAFC",
    neutral100: "#F1F5F9",
    neutral200: "#E2E8F0",
    neutral300: "#CBD5E1",
    neutral400: "#94A3B8",
    neutral500: "#64748B",
    neutral600: "#475569",
    neutral700: "#334155",
    neutral800: "#1E293B",
    neutral900: "#0F172A",

    accent:  "#F59E0B",
    accentHover: "#D97706",

    success: "#16A34A",
    successLight: "#DCFCE7",
    error:   "#DC2626",
    errorLight: "#FEE2E2",

    whatsapp: "#25D366",
    whatsappHover: "#1ebd5a",
  },

  radius: {
    xs:   "6px",
    sm:   "8px",
    md:   "12px",
    lg:   "16px",
    xl:   "20px",
    pill: "999px",
  },

  shadow: {
    card:   "0 1px 3px rgba(15,23,42,.04), 0 6px 20px rgba(15,23,42,.06)",
    hover:  "0 12px 32px rgba(15,23,42,.1), 0 4px 12px rgba(15,23,42,.04)",
    sticky: "0 -4px 20px rgba(15,23,42,.08)",
    modal:  "0 24px 48px rgba(15,23,42,.18)",
    button: "0 2px 8px rgba(0,0,0,.15)",
  },

  spacing: {
    sectionDesktop: "128px", // py-32
    sectionMobile:  "80px",  // py-20
    containerMax:   "1280px",
    gridGap:        "24px",
    gridGapMobile:  "12px",
    cardPadding:    "16px",
  },

  type: {
    h1:       { size: "48px", mobileSz: "32px",  weight: "800", lineHeight: "1.1",  tracking: "-0.03em" },
    h2:       { size: "36px", mobileSz: "26px",  weight: "700", lineHeight: "1.15", tracking: "-0.02em" },
    h3:       { size: "24px", mobileSz: "20px",  weight: "700", lineHeight: "1.25", tracking: "-0.015em" },
    body:     { size: "16px", mobileSz: "15px",  weight: "400", lineHeight: "1.65", tracking: "0" },
    bodySmall:{ size: "14px", mobileSz: "13px",  weight: "400", lineHeight: "1.6",  tracking: "0" },
    caption:  { size: "12px", mobileSz: "11px",  weight: "500", lineHeight: "1.4",  tracking: "0.02em" },
    cta:      { size: "16px", mobileSz: "15px",  weight: "700", lineHeight: "1",    tracking: "0.01em" },
    price:    { size: "22px", mobileSz: "18px",  weight: "800", lineHeight: "1.2",  tracking: "-0.02em" },
  },
} as const;

export const STOREFRONT_TOKENS = {
  colors: SF.colors,
  radius: SF.radius,
  shadows: {
    card:  SF.shadow.card,
    hover: SF.shadow.hover,
    modal: SF.shadow.modal,
  },
  typography: {
    h1Mobile: SF.type.h1.mobileSz,
    h2:       SF.type.h2.size,
    h3:       SF.type.h3.size,
    body:     SF.type.body.size,
    cta:      SF.type.cta.size,
  },
} as const;

export const formatTND = (value: number | string | undefined) => {
  const amount = Number(value || 0);
  return `${amount.toFixed(3)} TND`;
};

/** Theme-aware values: use CSS vars when ThemeEngine has set them */
export const themeVars = {
  shadowCard: 'var(--shadow-card, 0 1px 3px rgba(0,0,0,.04), 0 6px 20px rgba(0,0,0,.06))',
  shadowHover: 'var(--shadow-hover, 0 12px 32px rgba(0,0,0,.1), 0 4px 12px rgba(0,0,0,.04))',
  shadowButton: 'var(--shadow-button, 0 2px 8px rgba(0,0,0,.15))',
  radiusMd: 'var(--radius-md, 12px)',
  radiusLg: 'var(--radius-lg, 16px)',
  sectionSpacing: 'var(--section-spacing, 4rem)',
  sectionSpacingMobile: 'var(--section-spacing-mobile, 3rem)',
  containerMax: 'var(--container-max, 1280px)',
  colorPrimary: 'var(--color-primary, #2563EB)',
};
